<template>
    <div class="step-template">
        <div :class="`text-wrapper no-app step-${ this.appStep }`">
            <div class="left-wrapper">
                <h1>Bericht</h1>
    
                <p class="h2">Sind die Patientinnen und Patienten  zufrieden, ist auch das Praxis-Team zufrieden :)</p>
                
                <v-button
                    variant="primary"
                    color="green"
                    label="Blick in die App"
                    size="lg"
                    @onClick="actualStep()" 
                />
            </div>
            
            <a target="_blank" href="/uploads/manual_uploads/Report_for_physician_de.pdf" class="middle-wrapper">
                <!-- TODO: vymenit obrazek na desktopu za vetsi? -->
                <picture>
                    <source media="(max-width: 1024.99px)" srcset="/imgs/web/webdemo-doctors/app_step_25_tablet.webp 1x, /imgs/web/webdemo-doctors/app_step_25_tablet@2x.webp 2x">
                    <img src="/imgs/web/webdemo-doctors/app_step_25.webp" srcset="/imgs/web/webdemo-doctors/app_step_25.webp 1x, /imgs/web/webdemo-doctors/app_step_25@2x.webp 2x">
                </picture>

                <svg width="80" height="80" viewBox="0 0 80 80" fill="none" xmlns="http://www.w3.org/2000/svg">
                <circle cx="40" cy="40" r="36" fill="#AE85F6" fill-opacity="0.49"/>
                <path d="M36.6333 45.2333C34.2333 45.2333 32.1889 44.4 30.5 42.7333C28.8333 41.0444 28 39 28 36.6C28 34.2 28.8333 32.1667 30.5 30.5C32.1889 28.8333 34.2333 28 36.6333 28C39.0333 28 41.0667 28.8333 42.7333 30.5C44.4 32.1667 45.2333 34.2 45.2333 36.6C45.2333 37.5778 45.0778 38.5111 44.7667 39.4C44.4556 40.2667 44.0222 41.0444 43.4667 41.7333L51.1333 49.4C51.3556 49.6222 51.4667 49.9111 51.4667 50.2667C51.4667 50.6 51.3556 50.8889 51.1333 51.1333C50.9111 51.3556 50.6222 51.4667 50.2667 51.4667C49.9111 51.4667 49.6222 51.3556 49.4 51.1333L41.7333 43.4667C41.0667 44.0222 40.3 44.4556 39.4333 44.7667C38.5667 45.0778 37.6333 45.2333 36.6333 45.2333ZM36.6333 42.8C38.3444 42.8 39.8 42.2 41 41C42.2 39.7778 42.8 38.3111 42.8 36.6C42.8 34.8889 42.2 33.4333 41 32.2333C39.8 31.0333 38.3444 30.4333 36.6333 30.4333C34.9222 30.4333 33.4556 31.0333 32.2333 32.2333C31.0333 33.4333 30.4333 34.8889 30.4333 36.6C30.4333 38.3111 31.0333 39.7778 32.2333 41C33.4556 42.2 34.9222 42.8 36.6333 42.8Z" fill="#5937B7"/>
                </svg>
            </a>

            <figure class="shadow">
                <picture>
                    <img src="/imgs/web/webdemo-doctors/shadow_bottom.webp" srcset="/imgs/web/webdemo-doctors/shadow_bottom.webp 1x, /imgs/web/webdemo-doctors/shadow_bottom@2x.webp 2x">
                </picture>
            </figure>

            <div class="right-wrapper">
                <p class="h2">Klein anfangen, Großes erreichen</p>
            </div>
        </div>
    </div>
</template>

<script>
export default {

    props: {},
    data(){
        return {
            appStep: 25
        }
    },

    methods: {
        actualStep() {
            this.$emit('app-step', ++this.appStep)
        }
    }
}

</script>

